export default function UrlUidFactory() {
    var fn = this;

    fn.get_uid = function () {
        const url = new URL(window.location.href);
        return url.searchParams.get("uid"); //'0a3f50ad-722a-32b8-e044-0003ba298018';
    };

    return fn;
}
